import { useEffect } from 'react';
import { matchRoutes, useLocation } from 'react-router-dom';
import { featureRoutes } from '../config/feature-routes';

const titleSuffix = 'Social Good';
const fallbackTitle = 'Account';

export function resolveDocumentTitle(pathname: string): string {
  let title = fallbackTitle;
  // matchRoutes ranks a literal segment above a parameter, so /domains/view keeps its own
  // title rather than answering the one on /domains/:section.
  const matches = matchRoutes(
    featureRoutes.map((route) => ({ path: route.path, title: route.title })),
    pathname
  );
  if (matches !== null && matches.length > 0) {
    const matched = matches[matches.length - 1].route;
    if (matched.title.length > 0) {
      title = matched.title;
    }
  }
  return `${title} · ${titleSuffix}`;
}

export function useDocumentTitle(): void {
  const location = useLocation();
  useEffect(() => {
    document.title = resolveDocumentTitle(location.pathname);
  }, [location.pathname]);
}
